export default function () {
  this.sendEvent('core.clearWebViewCache', {})
}
